import Vue from "vue";

export function formatBusinessHours(restrictions) {
    if (!restrictions?.length) return '';

    // Проверяем, все ли дни недели присутствуют (1-7)
    const allDays = [1, 2, 3, 4, 5, 6, 7];
    const hasAllDays = allDays.every(day =>
        restrictions.some(r => r.days.includes(day))
    );

    if (hasAllDays) {
        // Берем время из первого ограничения (предполагаем, что оно одинаковое)
        const firstRestriction = restrictions[0];
        const from = String(firstRestriction.time_from.hours).padStart(2, '0') + ':' +
            String(firstRestriction.time_from.minutes).padStart(2, '0');
        const to = String(firstRestriction.time_to.hours).padStart(2, '0') + ':' +
            String(firstRestriction.time_to.minutes).padStart(2, '0');

        return Vue.prototype.$lang('delivery.workschedule') + ` ${from}–${to}`;
    }

    return Vue.prototype.$lang('delivery.workschedule.any');
}


export function extractPriceAndInterval(data) {
    // Извлекаем price из pricing_total и убираем валюту
    let price = 0;
    if (data.pricing_total) {
        // Убираем всё, кроме чисел, точки и знака минус
        const priceMatch = data.pricing_total.match(/[-+]?\d*\.?\d+/);
        price = priceMatch ? parseFloat(priceMatch[0]) : 0;
    }

    // Вычисляем interval
    let interval = 0;

    if (data.delivery_interval && data.delivery_interval.max) {
        const currentDate = new Date();
        const deliveryMaxDate = new Date(data.delivery_interval.max);

        // Проверяем, что даты корректны
        if (!isNaN(deliveryMaxDate.getTime())) {
            // Разница в миллисекундах, преобразуем в дни
            const diffTime = deliveryMaxDate - currentDate;
            interval = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        }
    }

    return {
        price: price,
        interval: interval
    };
}

